import { Card } from "~/screens/Hub/Home/components";
import { ExpandableGrid } from "~/screens/Hub/Resources/components/ExpandableGrid";
import { Resource } from "~/shared.types";
import { customIcons } from "~/ui/common/Icons";

interface GuidesSectionProps {
  resources: Resource[];
}

export const GuidesSection = ({ resources }: GuidesSectionProps) => (
  <section>
    <ExpandableGrid
      title="Elektra's Guides to Menopause"
      items={resources}
      renderCard={(item) => (
        <a href={item.link} target="_blank" rel="noopener noreferrer">
          <Card
            key={item.id}
            className="h-full flex-row items-start justify-between space-y-1 p-3 hover:bg-neutral-100/50"
          >
            <div className="space-y-2">
              <p className="text-violet font-sans text-xs font-semibold">
                ELEKTRA’S GUIDE TO MENOPAUSE
              </p>
              <h3 className="text-indigo font-sans">{item.title}</h3>
            </div>
            <div className="flex h-full items-center justify-center">
              <customIcons.ArrowUpRightIcon className="text-indigo size-6 shrink-0 stroke-1" />
            </div>
          </Card>
        </a>
      )}
    />
  </section>
);
